import type { ModalProps as MuiModalProps } from '@mui/material';
import { Modal as MuiModal } from '@mui/material';
import type { FC } from 'react';

/** Modal. Based on MUI Fade: https://mui.com/material-ui/react-modal */
export const Modal: FC<MuiModalProps> = (props) => {
  const { children } = props;

  return (
    <MuiModal data-testid="modal" {...props}>
      {children}
    </MuiModal>
  );
};
